// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"b6a480aa","301":"d7a2d5e9","335":"a3dfb66a","342":"7d9ae3e0","366":"200ca6d7","389":"c5f365d1","462":"cc7da012","539":"d1bb8fee","762":"ea92e51c","787":"37255720","849":"9f4f8338","928":"a2f5eda9"}[chunkId] + ".chunk.js";
};